import React, { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { Button, ButtonVariant } from '@patternfly/react-core';
import { useTranslation } from '../../localization/useTranslation.js';
import Icons, { Size } from '../Common/Icons.js';
import { getConfig } from '../../config.js';

export const SignInButton = () => {
  const { instance } = useMsal();
  const T = useTranslation();


  const handleLogin = useCallback(() => {
    const request = {
      scopes: [getConfig().msalConfig.auth.clientId]
    };
    instance.loginRedirect(request);
  }, [instance]);

  return (
    <Button
      variant={ButtonVariant.plain}
      onClick={() => handleLogin()}
    >
      <div style={{ color: 'white', display: 'inline-flex', alignItems: 'center' }} >
        <Icons.Login size={Size.LARGE}/>
        { T.common.login }
      </div>
    </Button>
  );
};
